import { action, observable } from "mobx";

import { AlertInfo, AlertInfoLevel } from "@typings/NotificationItem";

class NotificationStore {
  @observable alerts: AlertInfo[] = [];

  visibleErrors: string[] = [];

  @action alert(
    message: string,
    level?: AlertInfoLevel,
    options?: AlertInfo["options"],
  ) {
    if (this.visibleErrors.find(e => e === message)) {
      return;
    }

    this.alerts.push({ message, level, options });

    if (level === "error") {
      this.visibleErrors.push(message);
      setTimeout(() => {
        this.visibleErrors = this.visibleErrors.filter(e => e !== message);
      }, 10000);
    }
  }
}

export default new NotificationStore();
